import { withProps } from 'recompose';
import HeaderInner from '../../Header';

const Header = withProps({ product: 'SCPI' })(HeaderInner);

export default Header;
